var map = {
	"./banprime/logo-text-black.png": "fda9",
	"./ezzebank/logo-text-black.png": "51cf",
	"./groovebank/logo-text-black.png": "c349",
	"./hubchain/logo-text-black.png": "f968"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b41";